module.exports = __webpack_public_path__ + "static/media/Lenka_Kucerova.32159ae5.jpg";